export default __webpack_public_path__ + "static/media/sit-girl.eb5c6567.png";